import { AttendanceStatus } from "src/apis/dashboardAttendance";

export const STATUS_COLORS: Record<AttendanceStatus, string> = {
  completed: "#2e9e5b",
  scheduled: "#3f9fff",
  cancelled: "#e0a106",
  no_show: "#d64545",
};

export const STATUS_ORDER: AttendanceStatus[] = [
  "completed",
  "scheduled",
  "cancelled",
  "no_show",
];
